import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { apiService } from '../../../api/apiService';
import { Box, TableCell } from '@mui/material';
import RoutineStyle from "../../../components/GlobalPolicies/RoutineUpload.module.css";
import Slide from '@mui/material/Slide';
import { TransitionProps } from "@mui/material/transitions";
import FilePreview from '../utils/FilePreview/FilePreview';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const StyledTableRow = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

interface FileViewPopupProps {
  open: boolean;
  onClose: () => void;
  name: string;
  id: any;
  functionl1?: string;
  functionl2?: string;
  functionl3?: string;
  functionl4?: string;
  date?: any;
  updatedBy?: any;
  sectionTitle?: string;
  userDetail?: boolean;
  apiPath?: string; // New prop for the file details API path

}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});


export default function FileViewPopup({ open, onClose, name, id, functionl1, functionl2, functionl3, functionl4, date, sectionTitle, userDetail, apiPath, updatedBy }: FileViewPopupProps) {
  const [imageSrc, setImageSrc] = React.useState<string | null>(null);
  const [fileSize, setFileSize] = React.useState<any | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);
  console.log('date', date);
  console.log('functionl2functionl2functionl2', functionl2)


  React.useEffect(() => {
    if (open) {
      setLoading(true);
      setError(null);

      if (apiPath) {
        apiService(apiPath, "GET")
          .then((data) => {
            if (data.status === "success") {
              setImageSrc(data.data.doc_path);
              setFileSize(data.data.file_size);

            } else {
              throw new Error(data.message || "Failed to fetch image.");
            }
          })
          .catch((err) => {
            setError(err.message);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setError("API path is not defined.");
        setLoading(false);
      }
    } else {
      setImageSrc(null);
      setFileSize(null);
    }
  }, [open, id]);


  return (
    <BootstrapDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      TransitionComponent={Transition}
      sx={{
        '& .MuiDialog-paper': {
          width: '50%', maxWidth: 800, position: "absolute",
          top: "0%",
          right: "0%",
          bottom: "0%",
          height: '100%', margin: 1,
        }
      }}

    >

      <Typography variant="h6" sx={{ m: 0, p: 1, color: '#000', fontWeight: '600', fontSize: '16px' }} gutterBottom>
        {sectionTitle}
      </Typography>
      {/* <Typography  sx={{ m: 0, p: 1, color: '#000', fontSize: '16px' }}>
        Question : Root cause analysis & action plans for missed MICS controls defined within 1 month after being raised
      </Typography> */}
      <DialogTitle sx={{ m: 0, p: 1, color: '#000', fontWeight: '600', fontSize: '16px' }} id="customized-dialog-title">
        {name.split("_").slice(5).join("_")}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>

      <FilePreview
        loading={loading}
        error={error}
        imageSrc={imageSrc}
        name={name}
        // docPath={imageSrc || ''} // Pass the doc_path here
        fileSize={fileSize}
      />


      {userDetail ? (
        <Box>
          <StyledTableRow>
            <TableCell sx={{ border: 0 }}>
              <Typography className={RoutineStyle.userDetail}>Updated By</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <span color='#000'>{updatedBy || '---'}</span>
              </Box>
            </TableCell>
            <TableCell sx={{ border: 0 }}>
              <Typography className={RoutineStyle.userDetail}>Updated Date</Typography>
              <Typography variant="body2" color='#000'>{new Date(date).toLocaleDateString()}</Typography>
            </TableCell>
              <TableCell sx={{ border: 0 }}>
                <Typography className={RoutineStyle.userDetail}>Function L1</Typography>
                <Typography variant="body2" color='#000'>{functionl1 || '---'}</Typography>
              </TableCell>

              <TableCell sx={{ border: 0 }}>
                <Typography className={RoutineStyle.userDetail}>Function L2</Typography>
                <Typography variant="body2" color='#000'>{functionl2 || '---'}</Typography>
              </TableCell>

              <TableCell sx={{ border: 0 }}>
                <Typography className={RoutineStyle.userDetail}>Function L3</Typography>
                <Typography variant="body2" color='#000'>{functionl3 || '---'}</Typography>
              </TableCell>

              <TableCell sx={{ border: 0 }}>
                <Typography className={RoutineStyle.userDetail}>Function L4</Typography>
                <Typography variant="body2" color='#000'>{functionl4 || '---'}</Typography>
              </TableCell>




          </StyledTableRow>
        </Box>
      ) : (
        null
      )}

      {/* button section */}
      <Box
        bottom={0}
        padding={2}
        width="100%"
        sx={{
          boxShadow: '-1px -1px 13.2px 0px rgba(0, 0, 0, 0.1)',
          bgcolor: '#fff',
          zIndex: 10,
        }}>
        <Button variant="outlined" sx={{ color: '#000', borderColor: '#000' }} onClick={onClose}>
          Cancel
        </Button>
      </Box>
    </BootstrapDialog>
  );
}